<script>
    export let params;

    import MainContainer from "./MainContainer.svelte"
    import TicketList from "./TicketList.svelte";
    
    let ticketsSize = 0
    $: startAtDate = params.startAtDateMs >= 0 ? new Date(parseInt(params.startAtDateMs)) : new Date() 

	import {afterUpdate} from 'svelte';
	afterUpdate(async () => {
		const elems = document.querySelectorAll('.datepicker')
        const instances = M.Datepicker.init(elems)//, options);
	})

    function onStartDateInputChange(event) {
        const date = new Date(event.target.value)
        date.setHours(23); date.setMinutes(59); date.setSeconds(59);
        const startAtDateMs = date.valueOf()
        window.location.href = "/#/ClosedTickets/" + startAtDateMs
    }
</script>

<MainContainer>
    <h4>Closed tickets ({ticketsSize})</h4>
    <label for="start_at_date">Start at:</label>
    <input type="text" class="datepicker" id="start_at_date" value={startAtDate.toDateString()} on:change={onStartDateInputChange}/>

    <TicketList bind:ticketsSize order='desc' needReplyFromAdmin={false} {startAtDate} />
</MainContainer>